// must support both server and client components (because of serveral card components - e.g. EventCard / GlossarCard - which are inside (client-side) grid)
import React from "react";
import { customSanitize } from "@/utils/customSanitize";
import { hasParagraphTag } from "@/utils/hasParagraphTag";

const BLOCK_TAG_RE =
  /<\/?(address|article|aside|blockquote|div|dl|dt|dd|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|thead|tbody|tfoot|tr|td|th|ul|iframe)\b/i;

export const ContentTag = ({
  content,
  extraClass = "",
  isQuote = false,
}: {
  content: string;
  extraClass?: string;
  isQuote?: boolean;
}) => {
  const safe = String(customSanitize(content ?? ""));
  const hasBlockTags = BLOCK_TAG_RE.test(safe);
  const paragraphClass = hasParagraphTag(safe) ? "p" : "";
  const pClassName = extraClass.replace("inherit-parent", "").trim();

  if (isQuote) {
    const quoteClassName = `${paragraphClass} ${extraClass}`.trim();
    return (
      <blockquote
        className={quoteClassName || undefined}
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  if (hasBlockTags) {
    return (
      <div
        className={extraClass.trim() || undefined}
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  return (
    <p
      className={pClassName || undefined}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
};
